import { provideZoneChangeDetection } from "@angular/core";
/// <reference types="@angular/localize" />

import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";

import { AppModule } from "./app/app.module";
import { environment } from "./environments/environment";

if (!environment.enableConsoleOutput) {
  const noop = () => {};
  console.log = noop;
  console.info = noop;
  console.warn = noop;
  console.error = noop;
  console.debug = noop;
  console.trace = noop;
}

// ── DEV PREVIEW OVERRIDE ─────────────────────────────────────────────────────
// Append ?mobile=1 to the URL (query or hash) to force the mobile layout at ANY
// viewport width, app-wide — mirrors the native app, which is always mobile.
// Works by making the shared isMobile breakpoint (max-width: 991.98px) always
// report a match, so every BreakpointObserver-based component switches to mobile.
// Remove before production.
if (
  /[?&]mobile=1(?:&|$)/.test(window.location.search + window.location.hash) &&
  typeof window.matchMedia === "function"
) {
  const originalMatchMedia = window.matchMedia.bind(window);
  const MOBILE_BREAKPOINT = /max-width:\s*99(1\.98|2)px/;
  window.matchMedia = (query: string): MediaQueryList => {
    const mql = originalMatchMedia(query);
    if (!MOBILE_BREAKPOINT.test(query)) {
      return mql;
    }
    return {
      media: mql.media,
      matches: true,
      onchange: null,
      addEventListener: () => {},
      removeEventListener: () => {},
      addListener: () => {},
      removeListener: () => {},
      dispatchEvent: () => false,
    } as MediaQueryList;
  };
}
// ─────────────────────────────────────────────────────────────────────────────

// Public consent links remain usable with the app's HashLocationStrategy.
// Normalize the earlier /consent#token=... format before Angular parses routes.
if (
  /^\/consent\/?$/.test(window.location.pathname) &&
  !window.location.hash.startsWith("#/")
) {
  window.history.replaceState(null, "", "/#/consent" + window.location.hash);
}

platformBrowserDynamic()
  .bootstrapModule(AppModule, {
    applicationProviders: [provideZoneChangeDetection()],
  })
  .catch((err) => console.error(err));
